<template>
  <div class="loading">
    <md-progress-spinner :md-stroke="2" :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
    <span style="margin: 10px;">Loading...</span>
  </div>
</template>
<script>
export default {
  props: ['text']
}
</script>
<style scoped>
.loading {
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 2;
  top: 5vh;
  left: 50vw;
  padding: 10px;
  color: white;
  border-radius: 5px;
}
</style>
